module.exports = __webpack_public_path__ + "img/salon-cleanliness.b823cdc4.svg";